import React from "react";
import desafio from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-desafio.svg";
import colaboracion from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-colaboracion.svg";
import cliente from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-cliente.svg";
import globalidad from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-globalidad.svg";
import gente from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-valor-gente.svg";
import banner from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-valores-institucionales.webp";

/*eslint-disable */

declare const window: any;
const ValoresComponent: React.FC = () => {
  return (
    <div className="nuestro-valores" style={{ backgroundImage: `url(${banner})` }}>
      <div className="title">Valores institucionales</div>
      <div className="row justify-content-center">
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={desafio} alt="" />
            <div className="title">Desafío</div>
            <div className="description">Nos negamos a ser conformistas, aprovechamos cada desafío y confiamos en que alcanzaremos nuestras metas con pasión e ingenio.</div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={colaboracion} alt="" />
            <div className="title">Colaboración</div>
            <div className="description">Creamos sinergia con una comunicación mutua y cooperación genuina entre la compañía y nuestros socios.</div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={cliente} alt="" />
            <div className="title">Cliente</div>
            <div className="description">Promovemos una cultura centrada en el cliente, brindando calidad y servicios impecables.</div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={globalidad} alt="" />
            <div className="title">Globalidad</div>
            <div className="description">Impulsamos un enfoque global, conectando personas y mercados con innovación y calidad, para brindar soluciones sin fronteras.</div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 mb-4">
          <div className="intitucionales">
            <img className="logo" src={gente} alt="" />
            <div className="title">Gente</div>
            <div className="description">Creemos en el potencial de nuestros miembros y fomentamos una cultura que respete y desarrolle su talento.</div>
          </div>
        </div>
      </div>
     </div>
  );
};

export default ValoresComponent;
